module.exports = __webpack_public_path__ + "img/oilBlack.fd2a311f.svg";